import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=22dd33b1&scoped=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&id=22dd33b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd33b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22dd33b1')) {
      api.createRecord('22dd33b1', component.options)
    } else {
      api.reload('22dd33b1', component.options)
    }
    module.hot.accept("./TermsOfUse.vue?vue&type=template&id=22dd33b1&scoped=true", function () {
      api.rerender('22dd33b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/default/TermsOfUse.vue"
export default component.exports